const MIDDLE_DOT = '\u00B7'

type TeamInvitationSubtitleProps = {
  consumerName: string
  clientType: string
}

const TeamInvitationSubtitle = ({ consumerName, clientType }: TeamInvitationSubtitleProps) => {
  const subtitle = [consumerName, clientType].filter(Boolean).join(` ${MIDDLE_DOT} `)

  if (!subtitle) {
    return null
  }

  return <p className="text-[13px] leading-[18px] text-muted">{subtitle}</p>
}

export default TeamInvitationSubtitle
